"use strict";
/**
 * These are the possible emission status the emission can be in. They are
 * defined here in the same execution order as they can be registered.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.statusOrder = exports.PAYMENT_APPLICATION_FAILURE = exports.PAYMENT_APPLICATION_SUCCESS = exports.POLICY_ACTIVATION_FAILURE = exports.POLICY_ACTIVATION_SUCCESS = exports.PAYMENT_FAILED = exports.PAYMENT_DENIED = exports.PAYMENT_APPROVED = exports.POLICY_CREATION_FAILURE = exports.POLICY_CREATION_SUCCESS = exports.PERSON_CREATION_FAILURE = exports.PERSON_CREATION_SUCCESS = exports.RECEIVED = void 0;
/**
 * Unused
 */
exports.RECEIVED = 'PREC';
/**
 * Whether the person was created in acsel
 */
exports.PERSON_CREATION_SUCCESS = 'PERS';
exports.PERSON_CREATION_FAILURE = 'PERF';
/**
 * Whether the policy was created in acsel
 */
exports.POLICY_CREATION_SUCCESS = 'POCS';
exports.POLICY_CREATION_FAILURE = 'POCF';
/**
 * Whether the payment was approved or not by paguelofacil
 */
exports.PAYMENT_APPROVED = 'PAYA';
exports.PAYMENT_DENIED = 'PAYD';
exports.PAYMENT_FAILED = 'PAYF';
/**
 * Whether the policy was successfully activated in acsel
 */
exports.POLICY_ACTIVATION_SUCCESS = 'POAS';
exports.POLICY_ACTIVATION_FAILURE = 'POAF';
/**
 * Both of these statuses are considered as "success", since they represent when
 * the payment is applied in acsel and that is not a part of our emission process.
 */
exports.PAYMENT_APPLICATION_SUCCESS = 'PAAS';
exports.PAYMENT_APPLICATION_FAILURE = 'PAAF';
/**
 * Some endpoints return the status id, rather than the code. To generate the appropiate
 * code with an id, we need to use this array. The logic must basically be offset + 1.
 */
exports.statusOrder = [
    exports.RECEIVED,
    exports.PERSON_CREATION_SUCCESS,
    exports.PERSON_CREATION_FAILURE,
    exports.POLICY_CREATION_SUCCESS,
    exports.POLICY_CREATION_FAILURE,
    exports.PAYMENT_APPROVED,
    exports.PAYMENT_DENIED,
    exports.PAYMENT_FAILED,
    exports.POLICY_ACTIVATION_SUCCESS,
    exports.POLICY_ACTIVATION_FAILURE,
    exports.PAYMENT_APPLICATION_SUCCESS,
    exports.PAYMENT_APPLICATION_FAILURE,
];
//# sourceMappingURL=paymentCodes.js.map